import {
  SLINGER_X_SKUS,
  SLINGER_X_BUNDLE_SKUS,
  SLINGER_X_SIDE_SKUS,
} from '@/js/pages/product/rackbuilder/products/rack/functionalTrainer/FM/slinger-x/slingerXConstants'
import { getSlingerXPurchaseKey, isSlingerXConfigCarrierChild } from '@/js/pages/product/rackbuilder/products/rack/functionalTrainer/FM/slinger-x/slingerXUtils'
import { EMAIL_HIDDEN_KEY } from '../emailKeys'
import type { CustomProductVariant } from '../types'

export const slingerXVariant: CustomProductVariant = {
  id: 'slinger-x',
  // No featureFlag — Slinger X ships unflagged, unlike Cave/MS/MMS.

  matches: (product, groupProduct) => {
    const sku = product?.sku
    const groupSku = groupProduct?.sku

    return (!!sku && SLINGER_X_SKUS.includes(sku)) || (!!groupSku && SLINGER_X_SKUS.includes(groupSku))
  },

  skuSets: {
    allSkus              : SLINGER_X_SKUS,
    itemSkus             : SLINGER_X_SKUS,
    mainSkus             : SLINGER_X_BUNDLE_SKUS,
    qtyExcludedSkus      : SLINGER_X_SIDE_SKUS,
    addCountExcludedSkus : SLINGER_X_SIDE_SKUS,
  },

  // Delegates to the canonical resolver rather than re-deriving a second join-key implementation.
  purchaseKey: (item) => getSlingerXPurchaseKey(item),

  // The cart lists Slinger X accessories flat with no Rack/Left/Right sections, so the email only hides the same two config-carrier rows the cart summarises.
  emailLayout: (rogue, unit, child) => isSlingerXConfigCarrierChild(rogue, unit, child) ? { [EMAIL_HIDDEN_KEY]: '1' } : undefined,
}
